import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const AnimatedSuccessTick = ({ inProgress, variant, className }) => (
  <Box className={`${styles.badge} ${styles[variant] ?? ''} ${inProgress ? styles.inProgress : ''} ${className ?? ''}`} data-testid="animated-success-tick">
    <svg className={styles.check} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </Box>
);

AnimatedSuccessTick.defaultProps = {
  inProgress: false,
  variant: 'outlined',
  className: undefined,
};

AnimatedSuccessTick.propTypes = {
  inProgress: PropTypes.bool,
  variant: PropTypes.oneOf(['outlined', 'orange', 'blue']),
  className: PropTypes.string,
};

export default AnimatedSuccessTick;
